import React, { useState, useEffect } from "react";

const getLocationInfo = (location) => {
  if (!location) return null;
  const normalized = location.toUpperCase();
  if (normalized === "MX" || normalized === "MEXICO")
    return { emoji: "🇲🇽", label: "México" };
  if (
    normalized === "US" ||
    normalized === "USA" ||
    normalized === "ESTADOS_UNIDOS"
  )
    return { emoji: "🇺🇸", label: "Estados Unidos" };
  return null;
};

const TREND_TITLES = [
  "Vamos con TODO en X, bb 🔥",
  "Frase perrísima activa 🐩✨",
  "🔥 Tendencia del momento",
];

const NO_TREND_TITLES = [
  "No hay tendencia activa por ahora 💤",
  "Tomando un respiro perrísimo 💅",
  "Nos estamos preparando para la próxima bomba 💥",
  "Hoy no tuiteamos, pero pronto sí 😌",
  "Descansa esa manita tuitera, bb 🐾",
];

const getVpnGuideHref = (location, vpnLocation) => {
  const params = new URLSearchParams();
  if (location) params.set("country", location);
  if (vpnLocation) params.set("city", vpnLocation);
  const query = params.toString();
  return query ? `/ayuda-vpn?${query}` : "/ayuda-vpn";
};

const getRandom = (arr) => arr[Math.floor(Math.random() * arr.length)];

const TipsBox = ({ location, vpnLocation }) => (
  <div className="mt-4 p-4 rounded-2xl text-left text-sm text-gray-500 bg-violet-300/[0.12] border-[1.5px] border-violet-300">
    <p className="font-semibold mb-3 text-center text-brand-primary">
      🧠 Tips para apoyar la tendencia en X (Twitter):
    </p>
    <ul className="list-disc list-inside space-y-1">
      <li>Publica la frase tal cual, sin agregar algún hashtag</li>
      <li>Evita repetir la frase muchas veces seguidas</li>
      <li>Comenta, da RT, like y cita tuits con la frase</li>
      <li>Tuitéalo en el horario clave si puedes</li>
      <li>
        {vpnLocation ? (
          <>
            Si no estás en la ubicación de la tendencia, usa una VPN conectada a{" "}
            <strong>{vpnLocation}</strong> para que cuente mejor.
          </>
        ) : (
          <>
            Si no estás en el país de la tendencia, usa una VPN conectada a ese
            país (🇲🇽 México o 🇺🇸 Estados Unidos) para que cuente mejor.
          </>
        )}{" "}
        <a
          href={getVpnGuideHref(location, vpnLocation)}
          className="underline text-brand-primary"
        >
          ¿Necesitas ayuda?
        </a>
      </li>
    </ul>
    <p className="mt-3 italic text-xs text-center text-brand-muted">
      💖 ¡Tu apoyo hace toda la diferencia!
    </p>
  </div>
);

const TrendContent = ({ item }) => {
  const [title, setTitle] = useState("");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    setTitle(item ? getRandom(TREND_TITLES) : getRandom(NO_TREND_TITLES));
  }, [item]);

  const handleCopy = () => {
    navigator.clipboard.writeText(item.phrase);
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  const locationInfo = item?.location ? getLocationInfo(item.location) : null;

  return (
    <div className="max-w-2xl mx-auto px-5 py-6 text-center space-y-5 bg-white/[0.92] rounded-[20px] border-2 border-pink-300 shadow-card">
      <h1 className="text-xl font-bold leading-snug text-brand-primary">
        {title}
      </h1>

      {item && locationInfo && (
        <p className="text-xs font-semibold flex items-center justify-center gap-1 flex-wrap text-brand-muted">
          <span>{locationInfo.emoji}</span>
          <span>Tendencia en {locationInfo.label}</span>
          {item.vpnLocation && (
            <>
              <span>·</span>
              <span>📍 {item.vpnLocation}</span>
            </>
          )}
          <span>·</span>
          <a
            href={getVpnGuideHref(item.location, item.vpnLocation)}
            className="underline text-[gray]"
          >
            ¿Necesitas ayuda? → Guía VPN
          </a>
        </p>
      )}

      {item ? (
        <>
          <p className="text-lg font-semibold text-brand-dark">{item.phrase}</p>

          <div className="w-full flex flex-col items-center">
            <button
              onClick={handleCopy}
              className="py-2 px-6 rounded-full font-bold active:scale-95 transition-transform bg-custom-blue shadow-accent text-sky-900"
            >
              Copiar frase
            </button>
            <div
              className={`h-5 mt-2 text-xs font-semibold transition-opacity duration-300 text-brand-primary ${
                copied ? "opacity-100" : "opacity-0"
              }`}
            >
              ¡Frase copiada!
            </div>
            <a
              href={item.twitterUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 text-sm underline text-brand-muted"
            >
              Ir a X (Twitter)
            </a>
            <a
              href="/generate-tweet"
              className="mt-7 text-sm underline hover:font-semibold text-brand-primary"
            >
              ¿Sin ideas? Genera un tuit ✨
            </a>
          </div>

          <TipsBox location={item.location} vpnLocation={item.vpnLocation} />
        </>
      ) : (
        <>
          <p className="italic text-brand-muted">
            No hay tendencia activa en este momento, pero puedes prepararte con
            los tips perrísimos 💅
          </p>
          <TipsBox />
        </>
      )}
    </div>
  );
};

export default TrendContent;
